import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { NAV_LINKS, CONTACT_PHONE, CONTACT_PHONE_HREF, IMAGES } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={{
        backgroundColor: scrolled ? "rgba(10,15,22,0.92)" : "rgba(10,15,22,0.55)",
        backdropFilter: "blur(12px)",
        borderBottom: `1px solid ${scrolled ? "var(--ls-border)" : "transparent"}`,
      }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 md:h-[72px] flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2.5">
          <img
            src={IMAGES.logo}
            alt="LightSpeed ROI"
            className="h-11 md:h-12 w-auto object-contain"
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.href}
              to={l.href.startsWith("#") ? `/${l.href}` : l.href}
              className="font-cond font-semibold text-[15px] tracking-wide text-[#d7cdbf] hover:text-orange transition-colors uppercase"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-5">
          <a
            href={CONTACT_PHONE_HREF}
            className="flex items-center gap-2 font-cond font-bold text-[15px] tracking-wide text-white hover:text-orange transition-colors"
          >
            <Phone className="w-4 h-4 text-orange" /> {CONTACT_PHONE}
          </a>
          <Link to="/#cta" className="btn-orange text-sm">
            Get More Jobs
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          className="md:hidden text-white p-1"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-ls-alt border-t" style={{ borderColor: "var(--ls-border)" }}>
          <nav className="flex flex-col px-5 py-4 gap-1">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.href}
                to={l.href.startsWith("#") ? `/${l.href}` : l.href}
                onClick={() => setOpen(false)}
                className="font-cond font-semibold text-base tracking-wide text-[#d7cdbf] hover:text-orange transition-colors uppercase py-2"
              >
                {l.label}
              </Link>
            ))}
            <a
              href={CONTACT_PHONE_HREF}
              onClick={() => setOpen(false)}
              className="flex items-center gap-2 font-cond font-bold text-base tracking-wide text-white py-2"
            >
              <Phone className="w-4 h-4 text-orange" /> {CONTACT_PHONE}
            </a>
            <Link to="/#cta" onClick={() => setOpen(false)} className="btn-orange text-sm mt-2 justify-center">
              Get More Jobs
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
